import { useEffect } from 'react';

import { useCustomerTheme } from '../hooks/tenant/useCustomerTheme';
import { applyThemeVars, ensureFontLink } from '../utils/applyThemeVars';

/**
 * Pushes the tenant's theme overrides onto `<html>` as CSS custom properties.
 *
 * Renders nothing, and is mounted as a leaf rather than as a provider on purpose. `ChakraProvider`
 * sits above `<TRPC>` in `main.tsx` and its theme object is built at module-eval time, so fetched
 * overrides cannot reach the theme. They are applied as custom properties instead, which the Chakra
 * tokens already reference via `var(--peli-*, <static value>)`.
 *
 * Because this component returns `null` and nothing reads its state, the query settling re-renders
 * this leaf alone - the visible tree never reconciles, and the browser just recalculates style and
 * repaints. First paint uses the static per-tenant values baked in as the `var()` fallbacks, so
 * there is no flash of the wrong brand while the request is in flight.
 */
export const ThemeVarsSync = () => {
  const theme = useCustomerTheme();

  useEffect(() => {
    applyThemeVars(theme);
  }, [theme]);

  useEffect(() => {
    ensureFontLink(theme?.fonts?.url);
  }, [theme?.fonts?.url]);

  return null;
};
